import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import PerfectScrollbar from 'vue3-perfect-scrollbar'

createApp(App)
    .use(router)
    .use(createPinia())
    .use(PerfectScrollbar)
    .mount('#app')
